import classNames from 'classnames'

import callieOptionIcon from './assets/callie-option.svg'
import schedulingLinkOptionIcon from './assets/scheduling-link-option.svg'
import {
  callieOptionIconImageCss,
  optionIconCss,
  optionIconImageCss
} from './styles'

export const VariantIcon = ({ isCallie }: { isCallie: boolean }) => (
  <span
    className={optionIconCss}
    data-testid={isCallie ? 'callie-option-icon' : 'scheduling-link-option-icon'}
  >
    <img
      alt=""
      aria-hidden
      className={classNames(optionIconImageCss, { [callieOptionIconImageCss]: isCallie })}
      src={isCallie ? callieOptionIcon : schedulingLinkOptionIcon}
    />
  </span>
)
